"use client";
import { routeName } from "@/utils/commonfuntions";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React, { useState } from "react";
import AnimateHeight from "react-animate-height";

const SpecialityInfo = ({ data }) => {
  const currPath = usePathname();
  const [height, setHeight] = useState(200);

  return (
    <div className="max-w-7xl mx-auto px-4 py-6 md:py-7">
      <h2 className="text-3xl font-bold text-gray-900 mb-5 md:mb-6 text-center">
        Explore Treatments
      </h2>

      <AnimateHeight id="example-panel" duration={500} className="w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {data?.data[0]?.treatment_lists?.map((speciality, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 flex flex-col items-center p-6 border"
            >
              <div className="relative w-32 h-32 mb-6">
                <Image
                  loading="lazy"
                  src={
                    speciality?.treatment_list_detail?.img?.url ||
                    "/images/default-treatment.jpg"
                  }
                  alt={speciality.name}
                  width={128}
                  height={128}
                  className="object-contain"
                />
              </div>

              <Link
                href={{
                  pathname: `${currPath}/${routeName(speciality?.slug)}`,
                }}
                className="flex items-center gap-2 text-[#006daf] hover:text-blue-700 transition-colors group w-full justify-center border border-gray-100 rounded-3xl p-2"
              >
                <span className="font-medium text-center">
                  {speciality?.name}
                </span>
                <Image
                  loading="lazy"
                  src="/images/arrowRight1.svg"
                  alt="arrow right"
                  width={16}
                  height={16}
                  className="transition-transform group-hover:translate-x-1"
                />
              </Link>
            </div>
          ))}
        </div>
      </AnimateHeight>

      <button
        className="mt-5 md:mt-6 mx-auto block px-6 py-2 text-[#006daf] font-medium hover:text-blue-700 transition-colors"
        aria-expanded={height !== 0}
        aria-controls="example-panel"
        onClick={() => setHeight(height === 200 ? "auto" : 200)}
      >
        {height === 200 ? "Show More +" : "View Less -"}
      </button>
    </div>
  );
};

export default SpecialityInfo;
